module.exports = __webpack_public_path__ + "static/img/soccer.e7e9be5.jpg";